var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndWith(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19354_40643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19354_40643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 10.6663H10.6666V5.33301H5.33331V10.6663ZM7.99998 14.6663C7.07776 14.6663 6.21109 14.4913 5.39998 14.1413C4.58887 13.7913 3.88331 13.3163 3.28331 12.7163C2.68331 12.1163 2.20831 11.4108 1.85831 10.5997C1.50831 9.78856 1.33331 8.9219 1.33331 7.99967C1.33331 7.07745 1.50831 6.21079 1.85831 5.39967C2.20831 4.58856 2.68331 3.88301 3.28331 3.28301C3.88331 2.68301 4.58887 2.20801 5.39998 1.85801C6.21109 1.50801 7.07776 1.33301 7.99998 1.33301C8.9222 1.33301 9.78887 1.50801 10.6 1.85801C11.4111 2.20801 12.1166 2.68301 12.7166 3.28301C13.3166 3.88301 13.7916 4.58856 14.1416 5.39967C14.4916 6.21079 14.6666 7.07745 14.6666 7.99967C14.6666 8.9219 14.4916 9.78856 14.1416 10.5997C13.7916 11.4108 13.3166 12.1163 12.7166 12.7163C12.1166 13.3163 11.4111 13.7913 10.6 14.1413C9.78887 14.4913 8.9222 14.6663 7.99998 14.6663ZM7.99998 13.333C9.48887 13.333 10.75 12.8163 11.7833 11.783C12.8166 10.7497 13.3333 9.48856 13.3333 7.99967C13.3333 6.51079 12.8166 5.24967 11.7833 4.21634C10.75 3.18301 9.48887 2.66634 7.99998 2.66634C6.51109 2.66634 5.24998 3.18301 4.21665 4.21634C3.18331 5.24967 2.66665 6.51079 2.66665 7.99967C2.66665 9.48856 3.18331 10.7497 4.21665 11.783C5.24998 12.8163 6.51109 13.333 7.99998 13.333Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndWith);
export default __webpack_public_path__ + "static/media/end-with.18fba3d30d95b71786795c9a03aac360.svg";
export { ForwardRef as ReactComponent };